import React from 'react'
import bubblesBackground from '../assets/images/bubbles-background.png'

interface BubbleBackgroundProps {
  children: React.ReactNode
  className?: string
}

export const BubbleBackground: React.FC<BubbleBackgroundProps> = ({
  children,
  className = ''
}) => {
  return (
    <div className={`relative min-h-screen w-full bg-light-green ${className}`}>
      <div
        className="absolute inset-0 opacity-[0.125]"
        style={{
          backgroundImage: `url(${bubblesBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      <div className="relative">{children}</div>
    </div>
  )
}

export default BubbleBackground
